export default __webpack_public_path__ + "static/media/video.b8393810.png";